<template>
    <div class="m-5">
        <d-table :loading="loadingUsers" ref="table" :data="users" :show-detail-icon="false" >
            <template #action-buttons>
                <h2 class="text-primary-500 mb-0">
                    Users
                </h2>
            </template>
            <template slot-scope="props">
                <d-table-column field="fullName" :row="props.row" label="Name" sortable>
                    {{ props.row.firstName }} {{ props.row.lastName }}
                </d-table-column>
                <d-table-column field="systemEmail" :row="props.row" label="System Email" sortable>
                    {{ props.row.systemEmail }}
                </d-table-column>
                <d-table-column field="communities" :row="props.row" label="Communities" sortable>
                    {{ props.row.communities }}
                </d-table-column>
                <d-table-column field="rolesAsString" :row="props.row" label="Roles" sortable>
                    {{ props.row.rolesAsString }}
                </d-table-column>
                <d-table-column field="status" :row="props.row" label="Status" sortable>
                    {{ props.row.status }}
                </d-table-column>
            </template>
        </d-table>
    </div>
</template>

<script>
  import axios from 'axios';

  export default {
   
    name: 'SchoolUsersTabbedPage',
    parent: true,
    props: {
        school: {
            type: Object,
            default: () => {}
        }
    },

    data: () => ({
      activeTab: 0,
      users: [ ],
      loadingUsers: true,
    }),

        mounted() {
            this.getSchoolsUsers();
        },

        methods: {
            async getSchoolsUsers() {
                this.loadingUsers = true;
                console.log("TESTEST");
                const { data } = await axios.get(`/api/admin/users/school/${this.school.id}`);
                this.users = data;
                this.loadingUsers = false;
            },
        },
  };
</script>